"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/bluebird/js/release/filter.js
 ** module id = 416
 ** module chunks = 0
 **/